import { create } from "zustand";
import { querystring } from "zustand-querystring";
import { StockOverviewSortType } from "./StockOverviewFilterTypes";
import { StockOverviewContainerType } from "@sellar-io/api-v2/types";

export type ProductStatusType = "active" | "inactive" | null;
export type ItemStatusType = "visible" | "hidden" | null;

export type StockOverviewStoreState = {
  columnSort: StockOverviewSortType;
  search: string;
  preOrder: boolean;
  inStock: boolean;
  productStatus: ProductStatusType;
  itemStatus: ItemStatusType;
  containerType: StockOverviewContainerType | null;
};

type StockOverviewStoreActions = {
  setState: (state: StockOverviewStoreState) => void;
  setColumnSort: (columnSort: StockOverviewSortType) => void;
  setSearch: (search: string) => void;
  setPreOrder: (preOrder: boolean) => void;
  setInStock: (inStock: boolean) => void;
  setProductStatus: (productStatus: ProductStatusType) => void;
  setItemStatus: (itemStatus: ItemStatusType) => void;
  setContainerType: (containerType: StockOverviewContainerType | null) => void;
  reset: () => void;
};

const initialStockOverviewStoreState: StockOverviewStoreState = {
  columnSort: "created_desc",
  search: "",
  containerType: null,
  preOrder: false,
  inStock: false,
  productStatus: "active",
  itemStatus: null,
};

type StockOverviewStoreType = StockOverviewStoreState &
  StockOverviewStoreActions;

export const useStockOverviewStore = create<StockOverviewStoreType>()(
  querystring<StockOverviewStoreType>(
    (set) => ({
      ...initialStockOverviewStoreState,
      setState: (newState: StockOverviewStoreState) => set(newState),
      setColumnSort: (columnSort: StockOverviewSortType) => set({ columnSort }),
      setSearch: (search: string) => set({ search }),
      setPreOrder: (preOrder: boolean) => set({ preOrder }),
      setInStock: (inStock: boolean) => set({ inStock }),
      setProductStatus: (productStatus: ProductStatusType) =>
        set({ productStatus }),
      setItemStatus: (itemStatus: ItemStatusType) => set({ itemStatus }),
      setContainerType: (containerType: StockOverviewContainerType | null) =>
        set({ containerType }),
      reset: () => set(initialStockOverviewStoreState),
    }),
    {
      select(pathname) {
        const persistParam = pathname.includes("/stock-overview");
        return {
          columnSort: persistParam,
          search: persistParam,
          preOrder: persistParam,
          inStock: persistParam,
          productStatus: persistParam,
          itemStatus: persistParam,
          containerType: persistParam,
        };
      },
    },
  ),
);
